import React, { Fragment } from 'react';
import {
  smeBusinessToolkitTitles,
  smeBusinessToolkitSubHeadings,
  smeBusinessToolkitData
} from '../customTable/tables/sme-toolkits';
import {
  businessCompareTitles,
  businessCompareSubHeadings,
  businessCompareData
} from '../customTable/tables/business-compare';
import Pill from '../pill/Pill';
import PropTypes from 'prop-types';
import Tooltip from '../tooltip/Tooltip';

import tick from '../../../content/media-library/icons/yes.svg';
import info from '../../../content/media-library/icons/info.svg';

const CustomHeader = ({ title, link, linkText, className, amount, newPill, vat }) => {
  return (
    <th scope="col" className={className}>
      <div className="sme-business-toolkit__header-box">
        {newPill && <Pill text="new" />}
        <p className="sme-business-toolkit__txt sme-business-toolkit__txt--purple">{title}</p>
        <p className="sme-business-toolkit__txt">
          £<span className="sme-business-toolkit__txt sme-business-toolkit__txt--large">{amount}</span>.00
          <span className="sme-business-toolkit__txt sme-business-toolkit__txt--fade"> / mo</span>
        </p>
        {vat && <small>(inc. VAT)</small>}
        {link && (
          <a href={link} className="cta-button cta-button--secondary">
            {linkText}
          </a>
        )}
      </div>
    </th>
  );
};

const Header = ({ heading, bio, className }) => {
  return (
    <th scope="row" className={className}>
      <div>
        <p dangerouslySetInnerHTML={{ __html: heading }}></p>
      </div>
      {bio && <Tooltip heading={heading} bio={bio} />}
    </th>
  );
};

const Row = ({ className, children }) => {
  return <tr className={className}>{children}</tr>;
};

const Data = ({ data, className, icon }) => {
  return (
    <td className={className}>{data ? <img alt="Yes" src={icon} /> : <p className="screen-reader-text">No</p>}</td>
  );
};

const SmeToolkit = ({ caption, type }) => {
  let tableData = {};

  if (type === 'business') {
    tableData = {
      titles: businessCompareTitles,
      heading: businessCompareSubHeadings,
      details: businessCompareData
    };
  } else {
    tableData = {
      titles: smeBusinessToolkitTitles,
      heading: smeBusinessToolkitSubHeadings,
      details: smeBusinessToolkitData
    };
  }

  return (
    <table className="sme-business-toolkit">
      <caption className="screen-reader-text">{caption}</caption>
      <thead className="sme-business-toolkit__header">
        <Row className="sme-business-toolkit__row sme-business-toolkit__row--header">
          <td></td>
          {Object.entries(tableData.titles).map(([heading, info]) => (
            <CustomHeader
              type={info.type}
              key={info.type}
              title={heading}
              link={info.link}
              linkText={info.linkText}
              amount={info.amount}
              className={info.className}
              newPill={info.new}
              vat={info.vat}
            />
          ))}
        </Row>
      </thead>
      <tbody>
        {Object.entries(tableData.heading).map(([heading, catInfo]) => {
          return (
            <Fragment key={heading}>
              <Row className="sme-business-toolkit__row sme-business-toolkit__row--grey">
                <Header heading={heading} className="sme-business-toolkit__heading" />
                <Data className="sme-business-toolkit__col" />
                <Data className="sme-business-toolkit__col sme-business-toolkit__col--grey" />
                {type === 'business' && <Data className="sme-business-toolkit__col" />}
              </Row>
              {Object.entries(catInfo).map(([cat, data]) => (
                <Row key={cat} className="sme-business-toolkit__row">
                  <Header
                    info={info}
                    heading={data.name}
                    bio={data.bio}
                    className="sme-business-toolkit__sub-heading"
                  />
                  <Data icon={tick} data={tableData.details.free[cat]} className="sme-business-toolkit__col" />
                  <Data
                    icon={tick}
                    data={tableData.details.toolkit[cat]}
                    className="sme-business-toolkit__col sme-business-toolkit__col--grey"
                  />
                </Row>
              ))}
            </Fragment>
          );
        })}
      </tbody>
    </table>
  );
};

SmeToolkit.propTypes = {
  caption: PropTypes.string,
  type: PropTypes.oneOf(['sme', 'business'])
};

export default SmeToolkit;
